import { render, staticRenderFns } from "./reimbursementToProject.vue?vue&type=template&id=2489915f&scoped=true"
import script from "./reimbursementToProject.vue?vue&type=script&lang=ts"
export * from "./reimbursementToProject.vue?vue&type=script&lang=ts"
import style0 from "./reimbursementToProject.vue?vue&type=style&index=0&id=2489915f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2489915f",
  null
  
)

export default component.exports